import { SvgIcon, SvgIconProps } from '@mui/material'

const StationsOutlinedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.50557 14.9498C3.01704 14.7884 2.70975 14.2627 2.85707 13.7324L4.52374 7.73236C4.64397 7.29954 5.03805 7 5.48726 7H19.5226C19.9718 7 20.3659 7.29954 20.4862 7.73236L22.1528 13.7324C22.3001 14.2627 21.9929 14.7884 21.5043 14.9498C21.5047 14.9665 21.5049 14.9832 21.5049 15V19C21.5049 20.1046 20.6095 21 19.5049 21H5.50495C4.40038 21 3.50495 20.1046 3.50495 19V15C3.50495 14.9832 3.50516 14.9665 3.50557 14.9498ZM5.13623 13L6.24734 9H18.7626L19.8737 13H19.5063C19.5059 13 19.5054 13 19.5049 13H5.50495C5.50448 13 5.50402 13 5.50355 13H5.13623ZM5.50495 15L5.50495 19H19.5049V15H5.50495Z"
        fill="currentColor"
      />
      <path
        d="M4.50495 4C4.50495 3.44772 4.95266 3 5.50495 3H19.5049C20.0572 3 20.5049 3.44772 20.5049 4C20.5049 4.55228 20.0572 5 19.5049 5H5.50495C4.95266 5 4.50495 4.55228 4.50495 4Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default StationsOutlinedIcon
